import { render, staticRenderFns } from "./theme-template.page.vue?vue&type=template&id=a1a9fefc&"
import script from "./theme-template.page.vue?vue&type=script&lang=js&"
export * from "./theme-template.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports